export const APPROXIMATE_TILE_WIDTH = 300
